// Product comparison — localStorage list of product IDs, mirrors the
// wishlist module's shape. Click any [data-compare-toggle="<id>"] to
// add/remove. A floating toast confirms each action so the user knows
// the click registered (the link text otherwise looks unchanged).
//
// Visit /compare/ to see the side-by-side spec table — a custom page
// (page-compare.php) hydrates from the same key and renders details
// server-side for each selected product.

const KEY = 'haegoziya_compare';
const MAX = 4;                        // cap so the compare table stays readable

function load() {
    try {
        const raw = localStorage.getItem(KEY);
        const arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr.filter(n => Number.isFinite(n)) : [];
    } catch (e) {
        return [];
    }
}

function save(ids) {
    localStorage.setItem(KEY, JSON.stringify(ids));
    document.dispatchEvent(new CustomEvent('haegoziya:compare-changed', { detail: { ids } }));
}

function toggle(id) {
    id = parseInt(id, 10);
    if (!id) return { action: 'noop' };
    const ids = load();
    const idx = ids.indexOf(id);
    if (idx >= 0) {
        ids.splice(idx, 1);
        save(ids);
        return { action: 'removed', count: ids.length };
    }
    if (ids.length >= MAX) {
        return { action: 'full', count: ids.length, max: MAX };
    }
    ids.push(id);
    save(ids);
    return { action: 'added', count: ids.length };
}

// ── Toast feedback ──────────────────────────────────────────────
let toastEl;
function showToast(msg, variant = 'ok') {
    if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'compare-toast';
        document.body.appendChild(toastEl);
    }
    toastEl.dataset.variant = variant;
    toastEl.innerHTML = `
        <span class="compare-toast__msg">${msg}</span>
        <a class="compare-toast__cta" href="/compare/">View comparison →</a>
    `;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 3200);
}

// ── Paint state on any compare toggles + the header badge ──────
function paint() {
    const ids = new Set(load());
    document.querySelectorAll('[data-compare-toggle]').forEach(el => {
        const id = parseInt(el.getAttribute('data-compare-toggle'), 10);
        const on = ids.has(id);
        el.classList.toggle('is-saved', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
        // Live label swap (link/button can opt-in via data-compare-label-add / remove)
        const addLabel = el.getAttribute('data-compare-label-add');
        const remLabel = el.getAttribute('data-compare-label-remove');
        if (addLabel && remLabel) {
            el.textContent = on ? remLabel : addLabel;
        }
    });
    document.querySelectorAll('[data-compare-count]').forEach(el => {
        el.textContent = String(ids.size);
    });
}

// ── Click handler ───────────────────────────────────────────────
document.addEventListener('click', e => {
    const target = e.target.closest('[data-compare-toggle]');
    if (!target) return;
    e.preventDefault();
    const id = target.getAttribute('data-compare-toggle');
    const r = toggle(id);
    if (r.action === 'added')   showToast(`Added to comparison (${r.count}/${MAX})`);
    if (r.action === 'removed') showToast('Removed from comparison');
    if (r.action === 'full')    showToast(`You can compare up to ${MAX} products at once.`, 'warn');
});

document.addEventListener('haegoziya:compare-changed', paint);

// ── /compare/ page renderer ─────────────────────────────────────
//   The PHP template emits a <template data-compare-product="ID"> per
//   product; here we read the saved ID list, clone each cell of those
//   templates into the matching `[data-compare-row]` containers, and
//   re-render when the list changes.
function renderComparePage() {
    const empty = document.querySelector('[data-compare-empty]');
    const table = document.querySelector('[data-compare-table]');
    if (!table || !empty) return;        // not on the compare page

    const ids = load();
    if (!ids.length) {
        empty.hidden = false;
        table.hidden = true;
        return;
    }
    empty.hidden = true;
    table.hidden = false;

    // Reset cell containers, preserving the label span inside each row.
    table.querySelectorAll('[data-compare-row]').forEach(row => {
        row.querySelectorAll('[data-compare-cell]').forEach(n => n.remove());
    });

    ids.forEach(id => {
        const tpl = document.querySelector(`template[data-compare-product="${id}"]`);
        if (!tpl) return;
        const frag = tpl.content.cloneNode(true);
        // Each template's children are <span data-cell="…">. Stamp each
        // one into the row that matches its data-cell name.
        frag.querySelectorAll('[data-cell]').forEach(cell => {
            const row = table.querySelector(`[data-compare-row="${cell.dataset.cell}"]`);
            if (!row) return;
            const wrap = document.createElement('div');
            wrap.dataset.compareCell = '';
            wrap.dataset.productId   = id;
            // Move contents (template span is itself a node we don't need).
            while (cell.firstChild) wrap.appendChild(cell.firstChild);
            row.appendChild(wrap);
        });
    });
}

document.addEventListener('haegoziya:compare-changed', renderComparePage);

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { paint(); renderComparePage(); });
} else {
    paint();
    renderComparePage();
}
